<div class="table-responsive">
    <div class="flex-container">
        <h4>{{ '@scheduleDetail' | translate }}: {{ schedule?.name }}</h4>
        <div class="flex-spacer"></div>
        <div class="flex-container">
            <button mat-icon-button [hidden]="!canEdit || editable" (click)="updateIsEditing()"
                title="{{ '@edit' | translate }}">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button [hidden]="!canEdit || !editable" title="{{ '@save' | translate }}"
                (click)="updateSchedule()">
                <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button [hidden]="!canEdit || !editable" title="{{ '@cancel' | translate }}"
                (click)="updateIsEditing()">
                <mat-icon>cancel</mat-icon>
            </button>
        </div>
    </div>
    <div *ngIf="loading" class="loading-strip">
        <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <mat-tab-group animationDuration="100ms" [selectedIndex]="selectedIndex" (selectedTabChange)="onTabClick($event)"
        *ngIf="!loading">
        <mat-tab label="{{ '@summary' | translate }}">
            <form [formGroup]="scheduleForm">
                <div class="content" *ngIf="schedule">
                    <mat-card appearance="outlined">
                        <mat-card-content>
                            <mat-form-field class="padded-input" style=" width: 25%;">
                                <mat-label>{{ '@name' | translate }}</mat-label>
                                <input matInput class="text-black" formControlName="name" [disabled]="!editable">
                                <mat-error>
                                    {{ 'validate.form' | translate: { 'field': '@name' | translate } }}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="padded-input">
                                <mat-label>{{ '@category' | translate }}</mat-label>
                                <input matInput class="text-black" formControlName="category" [disabled]="!editable">
                                <mat-error>
                                    {{ 'validate.form' | translate: { 'field': '@category' | translate } }}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="padded-input">
                                <mat-label>{{ '@actions' | translate }}</mat-label>
                                <mat-select placeholder="Select Action" formControlName="action" class="text-black"
                                    [(ngModel)]="schedule.action" [disabled]="!editable">
                                    <mat-option *ngFor="let name of Actions | enumToArray" [value]="Actions[name]">
                                        {{name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    {{ 'validate.form' | translate: { 'field': '@actions' | translate } }}
                                </mat-error>
                            </mat-form-field>
                            <mat-slide-toggle checked="{{schedule?.isActive}}" (change)="ontoggle($event)"
                                color="primary" class="make-active" [disabled]="!editable">{{ '@activate' | translate }}
                            </mat-slide-toggle>
                            <br />
                            <mat-form-field class="padded-input">
                                <mat-label>{{ '@estimatedHours' | translate }}</mat-label>
                                <input matInput type="number" class="text-black" formControlName="hours"
                                    [disabled]="!editable">
                            </mat-form-field>                            
                            <mat-form-field class="padded-input half-sized">
                                <mat-label>{{ '@description' | translate }}</mat-label>
                                <input matInput class="text-black" formControlName="description" [disabled]="!editable">
                            </mat-form-field>                            
                            <br />
                            <mat-form-field>
                                <mat-label>{{ '@cfrSection' | translate }}</mat-label>
                                <mat-chip-grid #chipList [attr.aria-label]="'@enterCfrSection' | translate"
                                    [disabled]="!editable">
                                    <mat-chip-row *ngFor="let code of cfrSections" (removed)="remove(code)">
                                        {{code}}
                                        <button *ngIf="editable" matChipRemove>
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                    <input matInput formControlName="cfrSection" [disabled]="!editable"
                                        [placeholder]="'@enterCfrSection' | translate" [matChipInputFor]="chipList"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)">
                                </mat-chip-grid>
                            </mat-form-field>
                            <mat-card appearance="outlined">
                                <mat-card-header>
                                    <mat-card-title>
                                        <div class="icon-with-text">
                                            <mat-icon title="{{'@scheduleSensorTypeTitle' | translate}}">info</mat-icon>
                                            <span>
                                                {{ '@scheduleSensorType' | translate }}:
                                            </span>
                                        </div>
                                    </mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <!--SENSOR TYPE-->
                                    <app-dropdown-searchable labelText="{{'@sensorType' | translate}}"
                                        controlName="sensorType" [parentFormGroup]="scheduleForm"
                                        [data]="sensorTypes" keyName="id" valueName="name"
                                        [initialValue]="schedule?.sensorTypeId" [editable]="editable"
                                        class="biggerDropdown">
                                    </app-dropdown-searchable>
                                </mat-card-content>
                            </mat-card>
                            <app-orderable-list-view *ngIf="criteriaListData && criteriaRowDefinitions"
                                (optionAction)="onCriteriaAction($event)" [data]="criteriaListData"
                                [rowDefinition]="criteriaRowDefinitions" [enableSelecting]="editable"
                                [menuOptions]="menuOptions" tableTitle="@criteria">
                            </app-orderable-list-view>
                        </mat-card-content>
                    </mat-card>
                </div>
            </form>
        </mat-tab>
        <mat-tab label="{{ '@supportedVehicles' | translate }}" *ngIf="(schedule && schedule.id)">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <!--Supported Vehicles-->
                        <app-orderable-list-view *ngIf="supportedVehiclesListData && supportedVehiclesRowDefinitions"
                            (optionAction)="onSupportedVehiclesAction($event)" [data]="supportedVehiclesListData"
                            [rowDefinition]="supportedVehiclesRowDefinitions" [enableDragging]="editable"
                            [enableSelecting]="editable" [menuOptions]="menuOptions" tableTitle="@supportedVehicles">
                        </app-orderable-list-view>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{ '@parts' | translate }}" *ngIf="(schedule && schedule.id)">
            <div class="content">
                <mat-card appearance="outlined" *ngIf="supportedVehiclesListData.length < 1">
                    <mat-card-content color="warn">
                        <span class="icon-with-text">
                            <mat-icon class="warning">warning</mat-icon>
                            <div>
                                {{'@noSupportedVehiclesWarning' | translate }}
                            </div>
                        </span>
                    </mat-card-content>
                </mat-card>
                <mat-card appearance="outlined" *ngIf="supportedVehiclesListData.length > 0">
                    <mat-card-content>
                        <div class="flex">
                            <div class="full-sized">
                                <as-split direction="{{direction}}">
                                    <as-split-area [size]="50">
                                        <div>
                                            <app-part-table-avail [tenantId]="tenantId" [loading]="availLoading"
                                                (addData)="addPart($event)" (refreshData)="updateData($event)"
                                                [pagedResponse]="partsData">
                                            </app-part-table-avail>
                                        </div>
                                    </as-split-area>
                                    <as-split-area [size]="50">
                                        <div>
                                            <app-part-table-add altTitle="{{'@assignedParts' | translate}}"
                                                (deleteCallBack)="removeParts($event)" [tenantId]="tenantId"
                                                [parts]="schedule.parts">
                                            </app-part-table-add>
                                        </div>
                                    </as-split-area>
                                </as-split>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>